function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#27AE60",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.54 8.807c-.091-.111-.131-.15-.13-.29.005-.942.002-1.957.002-2.9 0-.737-.001-1.475.002-2.212.001-.355-.048-.405-.429-.405H9.12c-.278 0-.362.08-.362.344V5.74c.005.798.004 2.431-.004 2.777a.436.436 0 01-.092.251c-1.315 1.616-2.63 3.232-3.96 4.837-.218.263-.272.501-.101.787.006.01.262.52.456.579.13.039 3.279.039 9.447 0 .206 0 .628-.137.892-.437.107-.122.202-.715-.095-1.06-1.321-1.618-2.438-3.051-3.762-4.667z",
  fill: "#FFF"
}))));